import React, { useEffect, useState } from "react";
import {
  AuBankIcon,
  AuBankSmallIcon,
  BusinessInformationIcon,
  BusinessInformationRedIcon,
  BusinessSecurityIcon,
  BusinessSecurityRedIcon,
  CreateAccountIcon,
  ProjExelLogo,
} from "../../assets/images";

import "../SignUp/SignUpCard.scss";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  CheckUniquiEmailAndMobilePayloadType,
  GetAccountNoPaymentVoucherPayloadType,
  GetSignUpOtpPayloadType,
  SignUpOtpVerifyPayloadType,
  SignUpUserPayloadType,
} from "../../commonTypes/authTypes";
import {
  checkUniqueEmailSignUpAction,
  checkUniqueMobileNoSignUpAction,
  createOrderAction,
  getAccountNoPaymentVoucherAction,
  getOtpSignUpAction,
  getPincodeAction,
  getVerifyAuAccountNumberAction,
  resetAccountPaymentVoucherVefication,
  resetAuAccountNumberVerifyData,
  resetAuthError,
  resetAuthMessage,
  resetAuthSuccess,
  resetCityList,
  resetIsAccountNumberVerified,
  resetIsSignupEmail,
  resetIsSignUpMobileNo,
  resetIsVoucherCodeVerified,
  resetSignUpEmailError,
  resetSignUpEmailFetching,
  resetSignUpEmailMessage,
  resetSignUpMobileError,
  resetSignUpMobileFetching,
  resetSingUpMobileMessage,
  resetspecificPincodeInformation,
  resetStateList,
  resetStateListTotalCount,
  resetVerifyAccountNumberMessage,
  resetVerifyVoucherMessage,
  resetVerifyVoucherSuccess,
  signUpClientAction,
  signUpOtpVerifyAction,
  signUpOtpVerifyVoucherCodeAction,
  verifyPaymentAction,
} from "../../redux/auth";
import useDebounce from "../../customHooks/useDebounce";
import { isEmailValid } from "../../utils/commonFunctions";
import {
  AccountPaymentVerificationResponseType,
  CityListTypes,
  CountryListTypes,
  StateListTypes,
} from "../../redux/auth/authTypes";
import { ErrorSuccessModal, Loader } from "../commons";
import toast, { Toaster } from "react-hot-toast";
import LeftSideSignUpInfo from "../SignUp/LeftSideSignUpInfo";
import CreateAccountWithOtp from "../SignUp/CreateAccountWithOtp";
import VerifySignUpOtp from "../SignUp/VerifySignUpOtp";

import PasswordDetails from "../SignUp/PasswordDetails";
import AuAccountVerification from "./AuAccountVerification";
import BusinessDetailSecurity from "./BusinessDetailSecurity";
import ShowSubscriptionPlanModal from "./ShowSubscriptionPlanModal";
type UniqueMobileNoType = {
  operation: string | null;
  mobile: number | null | undefined;
};
export type DropDownType = {
  value: null | string;
  label: string;
};
type UniqueEmailType = {
  operation: string | null;
  email: string | null | undefined;
};
export type UserProfileDetailErrorType = {
  emailError: string;
  newPasswordError: string;
  newPasswordAgainError: string;
  countryError: string;
  stateError: string;
  cityError: string;
};
export type PasswordValidationType = {
  atLeast: boolean;
  upperCase: boolean;
  special: boolean;
  lowerCase: boolean;
  number: boolean;
};
export type UserDetailsType = {
  mobileNumber: string;
  otp: string;
  personalInfo: {};
  businessInfo: {};
  passworDetails: {
    email: string;
    password: string;
    newPassword: string;
  };
};
type AppProps = {
  emailMessage: null | string;
  emailFetching: boolean;
  isEmail: number | null;
  mobileMessage: null | string;
  mobileFetching: boolean;
  isMobileNo: number | null;
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateListTotalCount: number;
  stateFetching: boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  cityFetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  success: number | null;
  fetching: boolean;
  error: string | null;
  token: string | null;
  message: string | null;
  statusCode: number | null;
  auAccountNumberVerifyData: any;
  isVoucherCodeVerified: boolean;
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchResetEmailError: () => void;
  dispatchResetEmailMessage: () => void;
  dispatchResetEmailFetching: () => void;
  dispatchResetIsEmail: () => void;
  dispatchResetMobileError: () => void;
  dispatchResetMobileMessage: () => void;
  dispatchResetMobileFetching: () => void;
  dispatchResetIsMobileNo: () => void;
  dispatchSignUpClientAction: (data: SignUpUserPayloadType) => void;
  dispatchResetAccountPaymentVeficationAction: () => void;
  dispatchResetStateListTotalCount: () => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchGetOtpSignUpAction: (data: GetSignUpOtpPayloadType) => void;
  dispatchSignUpOtpVerifyAction: (data: SignUpOtpVerifyPayloadType) => void;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetAuthMessage: () => void;
  dispatchGetVerifyAuAccountNumberAction: (data: any) => void;
  dispatchResetAuAccountNumberVerifyData: () => void;
  dispatchSignUpOtpVerifyVoucherCodeAction: (data: any) => void;
  dispatchResetVerifyVoucherSuccess: () => void;
  dispatchResetVerifyVoucherMessage: () => void;
  verifyVoucherMessage: string | null;
  verifyVoucherSuccess: number | null;
  isAccountNumberVerified: boolean;
  accountPaymentVoucherVerification: AccountPaymentVerificationResponseType
  dispatchIsAccountNumberVerified: () => void;
  dispatchResetspecificPincodeInformation: () => void;
  specificPincodeInformation: any;
  dispatchGetPincodeAction: (data: any) => void;
  dispatchPaymentOrderAction: (data: any) => void;
  dispatchVerifyPaymentAction: (data: any) => void
  dispatchResetVerifyAccountNumberMessageAction: () => void;
  verifyAccountNumberMessage: string | null;
  auAccountNumberFetching: boolean;
  dispatchresetspecificPincodeInformation: () => void;

  dispatchResetIsVoucherCodeVerified: () => void;
  dispatchGetAccountNoPaymentVoucherAction: (data: GetAccountNoPaymentVoucherPayloadType) => void;
};
const AuSignUpCard = ({
  emailMessage,
  emailFetching,
  isEmail,
  success,
  fetching,
  error,
  token,
  message,
  statusCode,
  isVoucherCodeVerified,
  dispatchCheckUniqueMobileNoAction,
  dispatchResetIsVoucherCodeVerified,
  dispatchCheckUniqueEmailAction,
  mobileMessage,
  mobileFetching,
  isMobileNo,
  accountPaymentVoucherVerification,
  dispatchResetEmailError,
  dispatchResetEmailMessage,
  dispatchResetEmailFetching,
  dispatchResetIsEmail,
  dispatchResetMobileError,
  dispatchResetMobileMessage,
  dispatchResetMobileFetching,
  dispatchResetIsMobileNo,
  dispatchSignUpClientAction,
  dispatchGetAccountNoPaymentVoucherAction,
  dispatchResetAccountPaymentVeficationAction,
  countryList,
  countryListTotalCount,
  countryFetching,
  stateList,
  stateListTotalCount,
  stateFetching,
  cityList,
  cityListTotalCount,
  cityFetching,
  isState,
  isCity,
  auAccountNumberVerifyData,
  dispatchVerifyPaymentAction,
  dispatchPaymentOrderAction,
  dispatchResetStateListTotalCount,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchGetOtpSignUpAction,
  dispatchSignUpOtpVerifyAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetAuthMessage,
  dispatchGetVerifyAuAccountNumberAction,
  dispatchResetAuAccountNumberVerifyData,
  dispatchSignUpOtpVerifyVoucherCodeAction,
  dispatchResetVerifyVoucherSuccess,
  dispatchResetVerifyVoucherMessage,
  verifyVoucherMessage,
  verifyVoucherSuccess,
  isAccountNumberVerified,
  dispatchIsAccountNumberVerified,
  dispatchResetspecificPincodeInformation,
  specificPincodeInformation,
  dispatchGetPincodeAction,
  dispatchResetVerifyAccountNumberMessageAction,
  verifyAccountNumberMessage,
  auAccountNumberFetching,
  dispatchresetspecificPincodeInformation
}: AppProps) => {
  const [offset, setOffset] = useState<number>(0);

  const [text, setText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  const [countryDialCode, setCountryDialCode] = useState<DropDownType>({
    value: "+91",
    label: "🇮🇳 (+91)",
  });
  const [inputDetails, setInputDetails] = useState<any>({
     channel_partner: "au_bank",
    mobileNumber: "",
    otp: "",
    accountInfo: {},
    businessInfo: {},
    passworDetails: {
      email: "",
      password: "",
      newPassword: "",
    },
  });
  const [accountInfoDetails, setAccountInfoDetails] = useState<any>();
  const [uniqueEmail, setUniqueEmail] = useState<UniqueEmailType>({
    operation: "add",
    email: null,
  });
  const [uniqueMobileNo, setUniqueMobileNo] = useState<UniqueMobileNoType>({
    operation: "add",
    mobile: null,
  });
  const [typeOfEntity, setTypeOfEntity] = useState({
    value: "",
    label: "Select..",
  });
  const [userProfileDetailsError, setUserProfileDetailsError] =
    useState<UserProfileDetailErrorType>({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });
  const [showSubscriptionPlanModal, setShowSubscriptionPlanModal] =
    useState(false);

  const [currentStep, setCurrentStep] = useState(0); // 0: Mobile Number, 1: OTP, 2: Personal, 3: Business 4: Set Password
  const [activeStep, setActiveStep] = useState(0); // Initialize with 0 :create account , 1 : personal 2 : busniess 3: password
  const [isOtpVerify, setIsOtpVerify] = useState(false);
  const [passwordPopUpShow, setPasswordPopUpshow] = useState(false);
  const [voucherCode, setVoucherCode] = useState("");
  const [resendTimer, setResendTimer] = useState<number | null>(null);
  const [timerRemaining, setTimerRemaining] = useState(0);
  const [passwordValidation, setPasswordValidation] =
    useState<PasswordValidationType>({
      atLeast: false,
      upperCase: false,
      special: false,
      lowerCase: false,
      number: false,
    });
  const [paymentInitialized, setPaymentInitialized] = useState(false);
  const [planSelected, setPlanSelected] = useState<string>("Basic Plan")
  const [orderId, setOrderId] = useState("");
  const [orderDetails, setOrderDetails] = useState<any>({})
  const [isPaymentSuccessfull, setIsPaymentSuccessfull] = useState<boolean>(false)


  const loadScript = (src: string) => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };
  const onPayment = async (e: any) => {
    e.preventDefault();
    try {
      setPaymentInitialized(true);

      const res: any = await dispatchPaymentOrderAction({
        mobile_number: inputDetails?.mobileNumber,
        voucher_code: voucherCode,
        product_id: 1,
      });

      const orderId = res?.payload?.result?.razorpay_order?.id;
      setOrderId(orderId);

      const paymentObject = new (window as any).Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        order_id: orderId,
        theme: { color: '#dd4433' },
        modal: {
          ondismiss: () => {
            setPaymentInitialized(false);
            toast.error("Payment cancelled by user !", {
              duration: 2000,
            });
          },
        },
        handler: async (response: any) => {


          try {

            if (!response.razorpay_payment_id || !response.razorpay_order_id || !response.razorpay_signature) {
              toast.error("Payment incomplete or cancelled !", {
                duration: 2000,
              });

              setPaymentInitialized(false);
              return;
            }

            const data = {
              order_id: response.razorpay_order_id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature,
              mobile_number: inputDetails?.mobileNumber,
            };

            setOrderDetails(data);

            const result: any = await dispatchVerifyPaymentAction(data);

            if (result?.payload?.success) {
              // setCurrentStep(3);
              const persistedAccountInfo = localStorage.getItem("accountInfo");

              if (persistedAccountInfo) {
                handlePersonalInfoNext(JSON.parse(persistedAccountInfo))
              }
              setIsPaymentSuccessfull(true)
            } else {
              // toast.error("Payment verification failed !", {
              //   duration: 2000,
              // });
            }
          } catch (error) {
            // toast.error("An error occurred during payment verification !", {
            //   duration: 2000,
            // });
          } finally {
            setPaymentInitialized(false);
          }
        },
      });

      paymentObject.on('ready', () => {
        const container = document.querySelector('.razorpay-container');
        if (container) {
          container.classList.add('fullscreen-razorpay');
        }
      });

      paymentObject.open();

    } catch (error) {
      toast.error("Failed to initiate payment !", {
        duration: 2000,
      });

      setPaymentInitialized(false);
    }
  };

  useEffect(() => {
    loadScript('https://checkout.razorpay.com/v1/checkout.js')
    setUserProfileDetailsError({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });
    dispatchResetStateList();
    dispatchResetIsVoucherCodeVerified();
    dispatchResetCityList();
    dispatchResetAuthError();
    dispatchResetAuthMessage();
    dispatchResetVerifyVoucherSuccess();

    dispatchResetAccountPaymentVeficationAction();
    dispatchResetVerifyVoucherMessage();
    dispatchIsAccountNumberVerified();
    dispatchResetAuAccountNumberVerifyData();
    dispatchResetVerifyAccountNumberMessageAction();
    dispatchresetspecificPincodeInformation();
    localStorage.removeItem("accountInfo");
    localStorage.removeItem("businessDetail");
  }, []);
  useEffect(() => {
    let intervalId: any;
    if (timerRemaining > 0) {
      intervalId = setInterval(() => {
        setTimerRemaining((prev) => prev - 1);
      }, 1000);
    } else if (timerRemaining === 0 && resendTimer !== null) {
      setResendTimer(null);
    }
    return () => clearInterval(intervalId);
  }, [timerRemaining, resendTimer]);

  useDebounce(
    () => {
      if (inputDetails?.mobileNumber) {
        dispatchCheckUniqueMobileNoAction(uniqueMobileNo);
      }
    },
    500,
    [uniqueMobileNo]
  );

  useEffect(() => {
    const persistedAccountInfo = localStorage.getItem("accountInfo");
    const persistedBusinessInfo = localStorage.getItem("businessDetail");
    if (currentStep === 2) {
      if (persistedAccountInfo) {
        const parsedPersistedAccountInfo = JSON.parse(persistedAccountInfo);

        setInputDetails((prev: any) => ({
          ...prev,
          accountInfo: parsedPersistedAccountInfo,
        }));
      }
    } else if (currentStep === 3) {
      if (persistedBusinessInfo) {
        const parsedPersistedBusinessInfo = JSON.parse(persistedBusinessInfo);
        setInputDetails((prev: any) => ({
          ...prev,
          businessInfo: parsedPersistedBusinessInfo,
        }));
      }
    } else if (currentStep === 0) {
      localStorage.removeItem("accountInfo");
      localStorage.removeItem("businessDetail");
    }
  }, [currentStep]);


  useDebounce(
    () => {
      const emailValidation = !isEmailValid(
        inputDetails?.passworDetails?.email
      );
      if (emailValidation && inputDetails?.passworDetails?.email?.length) {
        setUserProfileDetailsError((prv: UserProfileDetailErrorType) => ({
          ...prv,
          emailError: "Email not valid",
        }));
      } else {
        setUserProfileDetailsError((prv: UserProfileDetailErrorType) => ({
          ...prv,
          emailError: "",
        }));
      }

      if (inputDetails?.passworDetails?.email) {
        dispatchCheckUniqueEmailAction(uniqueEmail);
      }
    },
    500,
    [uniqueEmail]
  );


  useEffect(() => {
    if (success === 1 && message === "OTP Verified Successfully!") {
      dispatchResetAccountPaymentVeficationAction()
      dispatchResetIsVoucherCodeVerified()
      dispatchGetAccountNoPaymentVoucherAction({ mobileNumber: inputDetails?.mobileNumber })
      setCurrentStep(2);
      setActiveStep(1);
    }
    if (
      success === 1 &&
      message === "OTP sent successfully to your mobile number!"
    ) {
      if (currentStep === 0) {
        toast.success("OTP sent successfully to your mobile number!", {
          duration: 2000,
        });

        setCurrentStep(1);
      }
    }
    if (error && error?.includes("Invalid OTP! Please try again!")) {
      setInputDetails((prevDetails: any) => ({
        ...prevDetails,
        otp: "",
      }));
    }

    if (
      currentStep === 1 &&
      success === 1 &&
      message === "OTP sent successfully to your mobile number!"
    ) {
      dispatchResetAuthSuccess();
      dispatchResetAuthMessage();
    }
    if (
      currentStep === 2 &&
      success === 1 &&
      message === "OTP Verified Successfully!"
    ) {
      dispatchResetAuthSuccess();
      dispatchResetAuthMessage();
    }
  }, [success, message, currentStep]);
  const handleMobileNext = async (data: any) => {
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();
    // setCurrentStep(1);
    setIsOtpVerify(true);
    dispatchGetOtpSignUpAction(data);
  };

  const handleOtpVerified = async (data: any) => {
    dispatchSignUpOtpVerifyAction(data);
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();

    setIsOtpVerify(false);
  };

  const handlePersonalInfoNext = (data: any) => {
    setAccountInfoDetails(data);
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();
    setInputDetails({ ...inputDetails, accountInfo: data });
    setCurrentStep(3);
    setIsOtpVerify(false);
    setActiveStep(2);
  };

  const handleToggleSubcriptionPlan = () => {
    setShowSubscriptionPlanModal(!showSubscriptionPlanModal);
  };

  const handleBusinessInfoNext = (data: any) => {
    setInputDetails({ ...inputDetails, businessInfo: data });
    setCurrentStep(4);
    setIsOtpVerify(false);
    setActiveStep(3);

    // setUserProfileDetailsError((prevState) => ({
    //   ...prevState,
    //   ...(!finalCountry?.value && { countryError: "Please choose a country!" }),
    //   ...(isState &&
    //     !addressState?.value && { stateError: "Please choose a state!" }),
    //   ...(isCity &&
    //     !selectedCityList?.value && { cityError: "Please choose a city!" }),
    // }));
  };
  const handleBackToPersonalInfo = (data: any) => {
    setInputDetails({ ...inputDetails, businessInfo: data });

    setCurrentStep(2);
    setActiveStep(1);
  };


  const handleBackToCreateAccount = () => {
    setCurrentStep(0);
  };
  const handleBackToBusinessAddress = () => {
    setCurrentStep(3);
    setActiveStep(2);
  };
  const handleEmailChange = (e: any) => {
    const finalData = {
      operation: "add",
      email: e.target.value,
    };
    setInputDetails((prevDetails: any) => ({
      ...prevDetails,
      passworDetails: {
        ...prevDetails.passworDetails,
        email: e.target.value,
      },
    }));

    setUniqueEmail(finalData);
    dispatchResetEmailError();
    dispatchResetEmailMessage();
    dispatchResetEmailFetching();
    dispatchResetIsEmail();
  };
  const handleInputChange = (e: any) => {
    if (e?.target?.name === "phone" && e?.target?.value?.length) {
      const finalData = {
        operation: "add",
        mobile: e?.target?.value?.trim(),
        email: null,
      };
      setUniqueMobileNo(finalData);
      dispatchResetMobileError();
      dispatchResetMobileMessage();
      dispatchResetMobileFetching();
      dispatchResetIsMobileNo();
    }

    const Value = e?.target?.value;
    setInputDetails((prev: any) => ({
      ...prev,
      mobileNumber: Value,
    }));
  };
  const isMobileView = () => {
    return window.innerWidth <= 480;
  };

  const handleVerifyAccountNumber = (data: string) => {
    let finalData = {
      ifsc_code: "AUBL0002011",
      account_number: data,
      mobile_number: inputDetails?.mobileNumber
    };
    dispatchGetVerifyAuAccountNumberAction(finalData);
  };

  const handleVerifyVocuher = (data: string) => {
    let finalData = {
      mobileNumber: inputDetails?.mobileNumber,
      voucherCode: data,
    };
    dispatchSignUpOtpVerifyVoucherCodeAction(finalData);
  };
  const handleSubmitUserDetail = (e: any) => {

    // e?.preventDefault();

    setUserProfileDetailsError({
      emailError: "",
      newPasswordError: "",
      newPasswordAgainError: "",
      countryError: "",
      stateError: "",
      cityError: "",
    });
    if (!inputDetails?.passworDetails?.email.trim().length) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        emailError: "Email is required",
      }));
    }

    if (
      !isEmailValid(inputDetails?.passworDetails?.email) &&
      inputDetails?.passworDetails?.email.trim().length
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        emailError: "Email not valid",
      }));
    }

    if (!inputDetails?.passworDetails?.password?.trim().length) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        passwordError: "Password is required",
      }));
    }

    if (
      inputDetails?.passworDetails?.newPassword?.length > 0 &&
      Object.values(passwordValidation).includes(false)
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        newPasswordError: "Password must meet requirements",
      }));
    }

    if (
      inputDetails?.passworDetails?.newPassword?.length > 0 &&
      inputDetails?.passworDetails?.newPassword !==
      inputDetails?.passworDetails?.password
    ) {
      setUserProfileDetailsError((prev: UserProfileDetailErrorType) => ({
        ...prev,
        newPasswordAgainError: "Password is not same",
      }));
    }

    if (
      inputDetails?.passworDetails?.email?.trim().length &&
      isEmailValid(inputDetails?.passworDetails?.email) &&
      inputDetails?.passworDetails?.password.trim().length &&
      inputDetails?.passworDetails?.newPassword?.length &&
      inputDetails?.passworDetails?.newPassword ===
      inputDetails?.passworDetails?.password &&
      !Object.values(passwordValidation).includes(false)
    ) {
      const updatedInputDetails = { ...inputDetails, businessInfo: e, orderId, orderDetails, isPaymentSuccessfull };
      setInputDetails(updatedInputDetails);

      const finalData = {
        inputDetails: updatedInputDetails,
      };
      dispatchSignUpClientAction(finalData);
    }
  };

  const handleErrorSuccessModal = () => {

    if (success === 0) {
      if (
        success === 0 &&
        message?.includes("Invalid OTP! Please try again!")
      ) {
        dispatchResetAuthSuccess();
        dispatchResetAuthError();
        toast.error("Invalid OTP! Please try again!", {
          duration: 2000,
        });
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    if (verifyVoucherSuccess === 0) {
      if (!!verifyVoucherMessage && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!verifyVoucherMessage}
            title="Error"
            message={verifyVoucherMessage}
            buttonText="OK"
            onPress={() => {
              dispatchResetVerifyVoucherMessage();
              dispatchResetVerifyVoucherSuccess();
            }}
          />
        );
      }
    }

    if (success === 1 && message?.includes("User Signed up successfully")) {
      setOrderId("")
      setOrderDetails({})
    }



    return false;
  };

  const steps = [
    {
      icon: CreateAccountIcon,
      redIcon: CreateAccountIcon,
    },
    {
      icon: AuBankSmallIcon,
      redIcon: AuBankSmallIcon,
    },
    {
      icon: BusinessSecurityIcon,
      redIcon: BusinessSecurityRedIcon,
    },
  ];
  return (
    <div className="">
      <div className="mainSignUpContainer">
        <div className="signUpLeft">
          <LeftSideSignUpInfo
            currentStep={currentStep}
            isOtpVerify={isOtpVerify}
            activeStep={activeStep}
          />
        </div>
        {currentStep === 0 && (
          <div className=" main-signup">
            <div className="signup-container">
              <div className="logo-section mb-3 mt-5">
                <img src={ProjExelLogo} style={{ height: "40px" }} />
                {isMobileView() && (
                  <img
                    src={AuBankIcon}
                    style={{ height: "40px", marginLeft: "27px" }}
                  />
                )}

                <div className="step-parent">
                  {steps?.map((step, index) => (
                    <>
                      <div key={index} className="step-indicator">
                        <span
                          className={`step${activeStep === index ? "active" : ""
                            }`}
                        >
                          <img
                            src={
                              activeStep === index || activeStep > index
                                ? step?.redIcon
                                : step?.icon
                            }
                            alt={" Icon"}
                          // className="left-pannel-image"
                          />
                        </span>
                        <span className="line"></span>
                      </div>
                    </>
                  ))}
                </div>
                <h5 className="mt-3">Create New Account</h5>
                <span className="description">
                  Enter your registered mobile number with AU Small Finance Bank.
                </span>
              </div>

              <CreateAccountWithOtp
                countryDialCode={countryDialCode}
                setCountryDialCode={setCountryDialCode}
                inputDetails={inputDetails}
                setInputDetails={setInputDetails}
                onNext={handleMobileNext}
                mobileFetching={mobileFetching}
                isMobileNo={isMobileNo}
                mobileMessage={mobileMessage}
                handleInputChange={handleInputChange}
              />

              <div className="flex-row">
                <p
                  className="resend-link text-center"
                  style={{ marginTop: "28px" }}
                >
                  Already have an account?{" "}
                  <a
                    style={{ color: "#dd4433", cursor: "pointer" }}
                    href="/login"
                    target="_blank"
                  >
                    Sign In
                  </a>
                </p>
              </div>

              <p className="mobileCopyright">
                &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
              </p>
            </div>
          </div>
        )}
        {currentStep === 1 && (
          <VerifySignUpOtp
            inputDetails={inputDetails}
            setInputDetails={setInputDetails}
            onVerify={handleOtpVerified}
            handleBackToCreateAccount={handleBackToCreateAccount}
            countryDialCode={countryDialCode}
            dispatchGetOtpSignUpAction={dispatchGetOtpSignUpAction}
            resendTimer={resendTimer}
            setResendTimer={setResendTimer}
            timerRemaining={timerRemaining}
            setTimeRemaining={setTimerRemaining}
            activeStep={activeStep}
          />
        )}

        {currentStep === 2 && (
          <AuAccountVerification
            onNext={handlePersonalInfoNext}
            activeStep={activeStep}
            handleVerifyAccountNumber={handleVerifyAccountNumber}
            auAccountNumberVerifyData={auAccountNumberVerifyData}
            handleVerifyVocuher={handleVerifyVocuher}
            handleToggleSubcriptionPlan={handleToggleSubcriptionPlan}
            verifyVoucherMessage={verifyVoucherMessage}
            isAuAccountNumberVerified={isAccountNumberVerified}
            dispatchIsAccountNumberVerified={dispatchIsAccountNumberVerified}
            voucherCode={voucherCode}
            setVoucherCode={setVoucherCode}
            onPayment={onPayment}
            setPlanSelected={setPlanSelected}
            planSelected={planSelected}
            message={message}
            accountPaymentVoucherVerification={accountPaymentVoucherVerification}
            setIsPaymentSuccessfull={setIsPaymentSuccessfull}
            isPaymentSuccessfull={isPaymentSuccessfull}
            isVoucherCodeVerified={isVoucherCodeVerified}
            setOrderId={setOrderId}
            dispatchResetIsVoucherCodeVerified={dispatchResetIsVoucherCodeVerified}
          />
        )}

        {currentStep === 3 && (
          <BusinessDetailSecurity
            onNext={handleBusinessInfoNext}
            onPrevious={handleBackToPersonalInfo}
            userProfileDetailsError={userProfileDetailsError}
            setUserProfileDetailsError={setUserProfileDetailsError}
            setText={setText}
            setOffset={setOffset}
            limit={limit}
            typeOfEntity={typeOfEntity}
            setTypeOfEntity={setTypeOfEntity}
            activeStep={activeStep}
            onPasswordNext={handleSubmitUserDetail}
            onPasswordPrevious={handleBackToBusinessAddress}
            inputDetails={inputDetails}
            setInputDetails={setInputDetails}
            handleEmailChange={handleEmailChange}
            email={inputDetails?.passworDetails?.email}
            password={inputDetails?.passworDetails?.password}
            newPassword={inputDetails?.passworDetails?.newPassword}
            passwordPopUpShow={passwordPopUpShow}
            passwordValidation={passwordValidation}
            setPasswordPopUpshow={setPasswordPopUpshow}
            setPasswordValidation={setPasswordValidation}
            isEmail={isEmail}
            planSelected={planSelected}
            emailMessage={emailMessage}
            emailFetching={emailFetching}
            specificPincodeInformation={specificPincodeInformation}
            dispatchGetPincodeAction={dispatchGetPincodeAction}
            dispatchResetspecificPincodeInformation={
              dispatchResetspecificPincodeInformation
            }
          />
        )}
        {currentStep === 4 && (
          <PasswordDetails
            onNext={handleSubmitUserDetail}
            onPrevious={handleBackToBusinessAddress}
            userProfileDetailsError={userProfileDetailsError}
            setUserProfileDetailsError={setUserProfileDetailsError}
            inputDetails={inputDetails}
            setInputDetails={setInputDetails}
            handleEmailChange={handleEmailChange}
            email={inputDetails?.passworDetails?.email}
            password={inputDetails?.passworDetails?.password}
            newPassword={inputDetails?.passworDetails?.newPassword}
            passwordPopUpShow={passwordPopUpShow}
            passwordValidation={passwordValidation}
            setPasswordPopUpshow={setPasswordPopUpshow}
            setPasswordValidation={setPasswordValidation}
            isEmail={isEmail}
            emailMessage={emailMessage}
            emailFetching={emailFetching}
            activeStep={activeStep}

          />
        )}
      </div>

      {showSubscriptionPlanModal && (
        <ShowSubscriptionPlanModal
          fetching={fetching}
          modal={showSubscriptionPlanModal}
          toggleModal={handleToggleSubcriptionPlan}
          sucess={success}
        />
      )}
      {handleErrorSuccessModal()}
      {auAccountNumberFetching && <Loader />}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailMessage: state.auth.signUpEmailMessage,
  emailFetching: state.auth.signUpEmailFetching,
  isEmail: state.auth.isSignupEmail,
  mobileMessage: state.auth.singUpMobileMessage,
  mobileFetching: state.auth.signUpMobileFetching,
  isMobileNo: state.auth.isSignUpMobileNo,
  countryList: state.auth.countryList,
  countryListTotalCount: state.auth.countryListTotalCount,
  countryFetching: state.auth.countryFetching,
  stateList: state.auth.stateList,
  stateListTotalCount: state.auth.stateListTotalCount,
  stateFetching: state.auth.stateFetching,
  cityList: state.auth.cityList,
  cityListTotalCount: state.auth.cityListTotalCount,
  cityFetching: state.auth.cityFetching,
  isState: state.auth.isState,
  isCity: state.auth.isCity,
  success: state.auth.success,
  message: state.auth.message,
  fetching: state.auth.fetching,
  error: state.auth.error,
  token: state.auth.token,
  statusCode: state.auth.statusCode,
  auAccountNumberVerifyData: state.auth.auAccountNumberVerifyData,
  verifyVoucherMessage: state.auth.verifyVoucherMessage,
  verifyVoucherSuccess: state.auth.verifyVoucherSuccess,
  isAccountNumberVerified: state.auth.isAccountNumberVerified,
  isVoucherCodeVerified: state.auth.isVoucherCodeVerified,
  specificPincodeInformation: state.auth.specificPincodeInformation,
  accountPaymentVoucherVerification: state.auth.accountPaymentVoucherVerification,
  verifyAccountNumberMessage: state.auth.verifyAccountNumberMessage,
  auAccountNumberFetching: state.auth.auAccountNumberFetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueEmailSignUpAction(data)),
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueMobileNoSignUpAction(data)),
  dispatchResetIsEmail: () => dispatch(resetIsSignupEmail()),
  dispatchResetEmailError: () => dispatch(resetSignUpEmailError()),
  dispatchResetEmailMessage: () => dispatch(resetSignUpEmailMessage()),
  dispatchResetEmailFetching: () => dispatch(resetSignUpEmailFetching()),
  dispatchResetMobileError: () => dispatch(resetSignUpMobileError()),
  dispatchResetMobileMessage: () => dispatch(resetSingUpMobileMessage()),
  dispatchResetMobileFetching: () => dispatch(resetSignUpMobileFetching()),
  dispatchResetIsMobileNo: () => dispatch(resetIsSignUpMobileNo()),
  dispatchSignUpClientAction: (data: SignUpUserPayloadType) =>
    dispatch(signUpClientAction(data)),

  dispatchGetVerifyAuAccountNumberAction: (data: any) =>
    dispatch(getVerifyAuAccountNumberAction(data)),
  dispatchResetStateListTotalCount: () => dispatch(resetStateListTotalCount()),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchGetOtpSignUpAction: (data: GetSignUpOtpPayloadType) =>
    dispatch(getOtpSignUpAction(data)),
  dispatchSignUpOtpVerifyAction: (data: SignUpOtpVerifyPayloadType) =>
    dispatch(signUpOtpVerifyAction(data)),

  dispatchSignUpOtpVerifyVoucherCodeAction: (
    data: SignUpOtpVerifyPayloadType
  ) => dispatch(signUpOtpVerifyVoucherCodeAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),

  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetAuthMessage: () => dispatch(resetAuthMessage()),
  dispatchResetAuAccountNumberVerifyData: () =>
    dispatch(resetAuAccountNumberVerifyData()),
  dispatchResetVerifyVoucherSuccess: () =>
    dispatch(resetVerifyVoucherSuccess()),
  dispatchResetVerifyVoucherMessage: () =>
    dispatch(resetVerifyVoucherMessage()),
  dispatchIsAccountNumberVerified: () =>
    dispatch(resetIsAccountNumberVerified()),
  dispatchResetspecificPincodeInformation: () =>
    dispatch(resetspecificPincodeInformation()),
  dispatchGetPincodeAction: (data: any) => dispatch(getPincodeAction(data)),

  dispatchresetspecificPincodeInformation: () => dispatch(resetspecificPincodeInformation()),
  dispatchPaymentOrderAction: (data: any) => dispatch(createOrderAction(data)),
  dispatchVerifyPaymentAction: (data: any) => dispatch(verifyPaymentAction(data)),
  dispatchResetVerifyAccountNumberMessageAction: () => dispatch(resetVerifyAccountNumberMessage()),

  dispatchGetAccountNoPaymentVoucherAction: (data: GetAccountNoPaymentVoucherPayloadType) => dispatch(getAccountNoPaymentVoucherAction(data)),
  dispatchResetAccountPaymentVeficationAction: () => dispatch(resetAccountPaymentVoucherVefication()),
  dispatchResetIsVoucherCodeVerified: () => dispatch(resetIsVoucherCodeVerified())
});

export default connect(mapStateToProps, mapDispatchToProps)(AuSignUpCard);
